import React from "react";
import { Link, useLocation } from "react-router-dom";
import { useCart } from "@/contexts/CartContext";
import { useAuth } from "@/contexts/AuthContext";
import { Home, Search, ShoppingCart, User, Grid3X3 } from "lucide-react";

const G = "#FFB800";

export default function MobileBottomNav({ onSearchOpen, onAuthOpen }) {
  const { pathname } = useLocation();
  const { itemCount } = useCart();
  const { isAuthenticated, isCustomer } = useAuth();

  const items = [
    { label: "Home", icon: Home, href: "/", match: (p) => p === "/" },
    { label: "Categories", icon: Grid3X3, href: "/categories", match: (p) => p.startsWith("/categories") || p.startsWith("/browse") },
    { label: "Search", icon: Search, action: onSearchOpen, match: () => false },
    { label: "Cart", icon: ShoppingCart, href: "/cart", match: (p) => p === "/cart", badge: itemCount },
    { label: "Account", icon: User, href: isAuthenticated && isCustomer ? "/account" : null, action: !isAuthenticated || !isCustomer ? onAuthOpen : null, match: (p) => p.startsWith("/account") },
  ];

  return (
    <nav className="md:hidden fixed bottom-0 left-0 right-0 z-50 safe-area-bottom"
      style={{ background: "rgba(255,249,240,0.96)", backdropFilter: "blur(16px)", borderTop: "1px solid rgba(0,0,0,0.06)" }}
      data-testid="mobile-bottom-nav">
      <div className="flex items-center justify-around h-14">
        {items.map(item => {
          const active = item.match(pathname);
          const El = item.href ? Link : "button";
          const props = item.href ? { to: item.href } : { onClick: item.action, type: "button" };
          return (
            <El key={item.label} {...props} data-testid={`mob-nav-${item.label.toLowerCase()}`}
              className="flex flex-col items-center justify-center gap-0.5 w-full h-full relative transition-colors active:scale-90"
              style={{ color: active ? G : "#8a8298" }}>
              <div className="relative">
                <item.icon className="w-5 h-5" strokeWidth={active ? 2.5 : 1.8} />
                {item.badge > 0 && (
                  <span className="absolute -top-1.5 -right-2 min-w-[16px] h-4 flex items-center justify-center text-[10px] font-bold rounded-full px-1"
                    style={{ background: G, color: "#fff" }}>
                    {item.badge}
                  </span>
                )}
              </div>
              <span className={`text-[10px] leading-none ${active ? "font-semibold" : "font-medium"}`}>{item.label}</span>
            </El>
          );
        })}
      </div>
    </nav>
  );
}
